export default {
      id: "font-m-usage",
      viewBox: "0 0 508 512",
      url: __webpack_public_path__ + "img/svg-sprite.svg#font-m",
      toString: function () {
        return this.url;
      }
    }